import TagsCell from 'routes/LeadList/components/TagsCell/TagsCell';

export default TagsCell;
